<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="59" viewBox="0 0 69 59">
        <path id="Rounded_Rectangle_1" data-name="Rounded Rectangle 1" class="cls-1" style="fill: #223369; fill-rule: evenodd;" d="M22.019,59H0.01L34.67,0,45.406,18.448Z"/>
        <path id="Rounded_Rectangle_1-2" data-name="Rounded Rectangle 1" class="cls-2" style="fill: #887850; fill-rule: evenodd;" d="M69.006,59H23.885L46.24,19.88Z"/>
    </svg>
</template>
